import { h, render } from "preact";

export default function CompareModalCta({ text, url }) {
  if (!text) return null;

  if (url)
    return (
      <a
        href={url}
        className="compare-modal-v2__cta button button--secondary"
        target="_blank"
      >
        {text}
      </a>
    );

  return (
    <button
      type="button"
      data-modal-trigger="compare-modal-blocks"
      className="compare-modal-v2__cta button button--secondary"
    >
      {text}
    </button>
  );
}
